import contentTypes from "@/view/constants/contentTypes";
import getArticleCategory from "../getArticleCategory";

/**
 * From content data and a collection from metadata, return display article category
 * @param {object} contentData
 * @param {array} contentMetadata
 * @returns {string}
 */
const getContentCategory = (contentData, contentMetadata) => {
  switch (contentData.content_type) {
    case contentTypes.ARTICLE:
      return getArticleCategory(contentData, contentMetadata);
  }
};

export default getContentCategory;
